export { default as CampaignPanel } from './campaignPanel';
export { default as CausePanel } from './causePanel';
export { default as GiveAssuredPanel } from './giveAssuredPanel';
export { default as GiveFeatures } from './giveFeatures';
export { default as ImagePanel } from './imagePanel';
export { default as CarouselPanel } from './carouselPanel';
export { default as LocationPanel } from './locationPanel';
export { default as ProgramPanel } from './programPanel';
export { default as TagsPanel } from './tagsPanel';
export { default as TestimonialPanel } from './testimonialPanel';
export { default as NewsletterPanel } from './newsletterPanel';
export { default as ImpactCard } from './impactCard';
export { default as ProgramHighlightPanel } from './programHighlightPanel';
export { default as VideoPanel } from './videoPanel';
export { default as BeneficiaryPanel } from './beneficiaryPanel';
export { default as CtaPanel } from './ctaPanel';
export { default as DonorBenfits } from './donorBenfits';
export { default as GiveAssuredPanelNew } from './giveAssuredPanelNew';
export { default as PatnersHomepage } from './patners';
export { default as MissionsCard } from './missionsCard';
export { default as TestimonialPanelNew } from './testimonialPanelNew';
export { default as MissionsPanel } from './missionsPanel';
export { default as JoinMissionPanel } from './joinMissionPanel';
export { default as CampaignPanelNew } from './CampaignPanelNew';
export { default as MissionPanelNew } from './missionPanelNew';

export { default as MediaPanel } from './mediaPanel';
export { default as DonorTestimonials } from './donorTestimonials';
export { default as CorporatePartners } from './corporatePartners';
export { default as NewsletterPanelNew } from './newsletterPanelNew';
export { default as Icrf } from './icrfPanel';
export { default as WhyGiveIndia } from './whyGiveIndiaPanel';
export { default as DonateWithTrust } from './donateWithTrustPanel';
export { default as SupportingFoundations } from './supportingFoundations';
export { default as FundraisersPanel } from './fundraisersPanel';
export { default as StartFundraisersPanel } from './startFundraisersPanel';
export { default as IndiaCovidResponse } from './indiaCovidResponse';





